<template>
  <div
    v-if="flds"
    class="row g-3 p-3 shadow justify-content-center bg-white border-20"
  >
    <header class="row w-100 header justify-content-center py-3">
      <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
        <router-link :to="'/ai/writing'">
          <div
            class="d-flex align-items-center justify-content-center border-20 hedaeritem"
          >
            دریافت موضوع از سیستم
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
        <router-link :to="'/ai/customwriting'">
          <div
            class="d-flex align-items-center justify-content-center border-20 hedaeritem"
          >
            ایجاد موضوع دلخواه
          </div>
        </router-link>
      </div>
      <div class="col-12 col-md-12 col-xl-4 col-lg-4 mb-2 mb-md-2 mb-xl-0 mb-lg-0">
        <div
          class="d-flex align-items-center justify-content-center border-20 hedaeritem active"
        >
          فهرست آزمون های انجام شده
        </div>
      </div>
    </header>
    <div class="col-12">
      <table class="w-100 rwd-table">
        <tbody>
          <tr className="w-100 bg-color-blue">
            <th className="font-size-12 text-center font-weight-300">شماره</th>
            <th className="font-size-12 text-center font-weight-300">نوع موضوع</th>
            <th className="font-size-12 text-center font-weight-300">تاریخ و ساعت آزمون</th>
            <th className="font-size-12 text-center font-weight-300">موضوع آزمون</th>
            <th className="font-size-12 text-center font-weight-300">عملیات</th>
          </tr>
              <tr v-if="!flds.data" className="w-100 nulltable">
                <td className="font-size-12 font-weight-300">در حال حاضر رکوردی وجود ندارد.</td>
              </tr>
              <tr v-else v-for="(f, i) in flds.data" :key="i" className="w-100 bg-color-blue">
                <td data-th="شماره" className="font-size-12 text-center font-weight-300">{{ f.id }}</td>
                <td data-th="نوع موضوع" className="font-size-12 text-center font-weight-300">{{ f.type == 'auto' ? 'سیستمی' : 'انتخابی' }}</td>
                <td data-th="تاریخ و ساعت آزمون" className="font-size-12 text-center font-weight-300"> {{ f.created_at }}</td>
                <td data-th="موضوع آزمون" className="font-size-12 text-center font-weight-300">{{ f.topic.substring(0, 50) }}</td>
                <td data-th="عملیات" className="font-size-12 text-center font-weight-300"><router-link
                    class="text-orange"
                    style="font-size: 14px;"
                    :to="'/ai/writing/' + f.id"
                  >
                  مشاهده جزئیات
                  </router-link>
                </td>
              </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import btn from "../../../UI/button/btn.vue";
import textInput from "../../../UI/input/textInput.vue";
import selectInput from "../../../UI/input/selectInput.vue";
import userImg from "../../../UI/userImg/userImg.vue";
import pageNavigation from "../../../UI/pageNavigation/pageNavigation.vue";
import previewImage from "../../../UI/uploadFile/previewImage.vue";
import { indexFinder } from "../../../assets/library/filter.js";

export default {
  name: "self_part1",
  data() {
    return {
      imgurl: window.imgurl,
      baseurl: window.baseurl,
      location: { ok: false, data: [] },
      degrees: { ok: false, data: [] },
      field: { ok: false, data: [] },
      category: { ok: false, data: [] },
      flds: { ok: false, data: [] },
      topic: "",
      variable: "",
      data: "",
      score: "",
      username: [],
      indexFinder: indexFinder,
      val: {
        lP: "",
        lC: "",
        d: "",
        c: "",
        f: "",
        e: "",
      },
    };
  },
  components: {
    btn,
    textInput,
    selectInput,
    pageNavigation,
    userImg,
    previewImage,
  },
  props: {
    flds: {
      default: [],
    },
  },
  mounted() {
    this.getLocation();
    this.crmslist();
  },
  methods: {
    updateTheVariable(value) {
      this.variable = value;
    },
    getLocation(THIS = this) {
      window.$.get(
        this.baseurl + "location/list",
        {},
        function (D) {
          THIS.location = D;
          THIS.getField();
        },
        "json"
      );
    },

    getField(THIS = this) {
      window.$.get(
        this.baseurl + "field/list",
        {},
        function (D) {
          THIS.field = D;
        },
        "json"
      );
    },
    //**********************************************************************
    crmslist(THIS = this) {
      // if(this.$localStorage.get("user").username.role == 3) {
      window.$.post(
        this.baseurl + "ai/selecttopics",
        {
          user_id: this.$localStorage.get('user').username.id,
        },
        function (D) {
          if (D.data) {
            THIS.flds = { ok: true, data: D.data };
          }
        },
        "json"
      );
      // }
    },
    //**********************************************************************
    sav(THIS = this) {
      const formdata = new FormData();
      formdata.append("topic", THIS.topic);
      formdata.append("writing", THIS.variable);
      formdata.append("topicid", this.$route.params.id);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };

      document.getElementById("alertsendresponse").innerText =
        "لطفا برای دریافت نمره آزمون صبر کنید...";

      fetch(THIS.baseurl + "ai/correction", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          console.log("result", JSON.parse(result.data));
          THIS.data = JSON.parse(result.data);
          document.getElementById("topic3").innerHTML = result.data.replace(
            /\\n/g,
            "<br />"
          );
          document.getElementById("topic3").style.height = "auto";
          document.getElementById("alertsendresponse").innerHTML = "";
        })
        .catch((error) => console.error(error));
    },
    //**********************************************************************
    sav2(THIS = this) {
      const formdata = new FormData();
      formdata.append("topic", THIS.topic);
      formdata.append("writing", THIS.variable);
      formdata.append("score", THIS.score);

      const requestOptions = {
        method: "POST",
        body: formdata,
        redirect: "follow",
      };
      fetch(THIS.baseurl + "ai/revision", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          document.getElementById("topic4").innerHTML = result.data.replace(
            /\\n/g,
            "<br />"
          );
          document.getElementById("topic4").style.height = "auto";
        })
        .catch((error) => console.error(error));
    },
  },
};
</script>
<style>
.border-20 {
  border-radius: 20px;
}

.headerai > h4 {
  font-size: 14px;
  font-weight: 400 !important;
  color: #000;
}

.ai-item {
  height: 240px;
  border: 2px solid #eee7d0;
  cursor: pointer;
  box-shadow: 0;
  transition: 0.3s ease-in-out;
}

.ai-item:hover {
  box-shadow: 0px 4px 4px 0px #00000040;
  background-color: #fffcf8 !important;
  transition: 0.3s ease-in-out;
}

.ai-item header h3 {
  color: #000;
  font-size: 14px;
  font-weight: 800;
}

.ai-item.disable header h3 {
  color: #676767;
}
.hedaeritem {
  height: 72px;
  background-color: #f0f0f0;
  font-size: 14px;
  font-weight: 800;
  color: #808285;
}

.hedaeritem.active {
  background-color: #fff7e9;
  box-shadow: 0px 4px 4px 0px #00000040;
  color: #000;
}

.header {
  border-bottom: 1px solid #d1d3d4;
}
.para {
  font-size: 11px;
  color: #000;
}
.addtopic {
  border-radius: 10px;
  width: 278px;
  height: 44px;
  font-size: 12px;
  font-weight: 800;
  background-color: #e6e7e8;
  color: #808285;
}
.savetopic {
  border: 1px solid #c6c6c6;
  height: 60px;
  width: 104px;
  background-color: #f5fafd;
  font-size: 14px;
  color: #676767;
  border-radius: 10px;
}

.textarea {
  height: auto;
  border: 1px solid #c6c6c6;
  background-color: #f5fafd;
  font-size: 14px;
  color: #676767;
  border-radius: 10px;
  direction: ltr;
}
.sendresponse {
  height: 44px;
  width: 180px;
  background-color: #1b60c6;
  border-radius: 10px;
  color: #fff;
  font-size: 12px;
  cursor: pointer;
}
.responseitem span {
  color: #1b60c6;
  font-family: "IRANYekanBlack";
  font-size: 14px;
  font-weight: 800;
}

.responseitem p {
  color: #676767;
  font-size: 14px;
  direction: ltr;
}

.responsehedaer h3 {
  color: #000;
  font-size: 14px;
  font-weight: 800;
}

.responsehedaer {
  border-bottom: 1px solid #d1d3d4;
}
.alertsendresponse {
  font-size: 14px;
  color: #aa000c;
}

.btnback {
  height: 44px;
  border-radius: 10px;
}

.btnback.white {
  font-size: 12px;
  color: #1b60c6;
  border: 1px solid #1b60c6;
  cursor: pointer;
}
.btnback.green {
  font-size: 12px;
  color: #fff;
  border: 1px solid #1b60c6;
  background-color: #1b60c6;
  cursor: pointer;
}

.sendscore {
  font-size: 12px;
  width: 180px;
  height: 44px;
  border-radius: 10px;
  color: #000;
  background-color: #faa61a;
  cursor: pointer;
}

table tbody  th {
  text-align: center !important;
  font-size: 12px;
  color: #1b60c6 !important;
  background: #fff !important;
  padding: 0.63rem 0.63rem !important;
  border-bottom-width: 10px;     
}
table > thead  th:last-child {
  border-radius: 10px 0 0 0 !important;        
}
table > thead  th:first-child {
  border-radius: 0 10px 0 0 !important;        
}

table tbody td {
  text-align: center !important;
  font-size: 12px;
  color: #676767 !important;
  padding: 0.63rem 0.63rem !important;
  background-color: transparent !important;
  border-bottom-width: 0 !important;
}

table tbody tr:nth-child(odd) {
  background-color: #F5FAFD !important;
}

table tbody tr:nth-child(even) {
  background-color: #fff !important;
}

.rwd-table {
    margin: auto;
    min-width: 300px;
    max-width: 100%;
    border-collapse: collapse;
  }
  
  .rwd-table tr:first-child {
    border-top: none;
    background: #0E2050;
    color: #fff;
  }
  
  .rwd-table tr {
    border-top: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    background-color: #f5f9fc;
  }
  
  .rwd-table tr:nth-child(odd):not(:first-child) {
    background-color: #ebf3f9;
  }
  
  .rwd-table th {
    display: none;
  }
  
  .rwd-table td {
    display: block;
  }
  
  .rwd-table td:first-child {
    margin-top: .5em;
  }
  
  .rwd-table td:last-child {
    margin-bottom: .5em;
  }
  
  .rwd-table td:before {
    content: attr(data-th) ": ";
    font-weight: bold;
    width: 120px;
    display: inline-block;
    color: #000;
  }
  
  .rwd-table th,
  .rwd-table td {
    text-align: left;
  }
  
  .rwd-table {
    color: #333;
    border-radius: .4em;
    overflow: hidden;
  }
  
  .rwd-table tr {
    border-color: #bfbfbf;
  }
  
  .rwd-table th,
  .rwd-table td {
    padding: .5em 1em;
  }
  @media screen and (max-width: 601px) {
    .rwd-table tr:nth-child(2) {
      border-top: none;
    }

    .rwd-table th,
    .rwd-table td {
        text-align: right !important;
    }
  }
  @media screen and (min-width: 600px) {
    .rwd-table tr:hover:not(:first-child) {
      background-color: #d8e7f3;
    }
    .rwd-table td:before {
      display: none;
    }
    .rwd-table th,
    .rwd-table td {
      display: table-cell;
      padding: .25em .5em;
    }
    .rwd-table th:first-child,
    .rwd-table td:first-child {
      padding-left: 0;
    }
    .rwd-table th:last-child,
    .rwd-table td:last-child {
      padding-right: 0;
    }
    .rwd-table th,
    .rwd-table td {
      padding: 1em !important;
    }
  }


</style>
